import { computed } from 'vue';
import { getUserInfo } from '../api/request';

export function useAuth() {
  const currentUser = computed(() => getUserInfo());

  const currentRole = computed(() => currentUser.value?.role || null);

  function hasRole(roles) {
    const role = currentRole.value;
    if (!role) return false;
    return roles.includes(role);
  }

  function isAdmin() {
    return currentRole.value === 'admin';
  }

  function getCurrentUser() {
    return currentUser.value;
  }

  function getCurrentRole() {
    return currentRole.value;
  }

  return {
    currentUser,
    currentRole,
    hasRole,
    isAdmin,
    getCurrentUser,
    getCurrentRole
  };
}
